import React from 'react'; 
import PageSplashCarousel from './PageSplashCarousel';
import PageCenteredText from './PageCenteredText';
import PageLongformText from './PageLongformText';
import PageImage from './PageImage';
import PageImages from './PageImages';
import PageBrand from './PageBrand';
import PageUSPs from './PageUSPs';
import PageTeam from './PageTeam';
import PageProjects from './PageProjects';
import PageNews from './PageNews';
import PagePartners from './PagePartners';
import PagePartnerEnquiry from './PagePartnerEnquiry';
import PageContact from './PageContact';
import PageContactPMG from './PageContactPMG';
import PageContactWillis from './PageContactWillis';
import PageRule from './PageRule';
import PagePattern from './PagePattern';

import WithConsumer from '../../context/WithConsumer';


const PageBlock = ({index,context,loaded}) => {
 	
 	if (context.posts) {
	 	
    	const posts 		= () => context.posts;
		const post 			= posts()[0];
		const block 		= post.block[index]; 
		    
		let content = '';
		
		if (block.type == 'splash_carousel') {
		
		    content = <PageSplashCarousel block={block} loaded={loaded}></PageSplashCarousel>
		    
		} else if (block.type == 'centered_text') {
		
		    content = <PageCenteredText block={block}></PageCenteredText>
		    
		} else if (block.type == 'longform_text') {
		
		    content = <PageLongformText block={block}></PageLongformText>
		
		} else if (block.type == 'image') {
		
		    content = <PageImage block={block}></PageImage>
		    
		} else if (block.type == 'images') {
		
		    content = <PageImages block={block}></PageImages>
		    
		} else if (block.type == 'brand') {
		
		    content = <PageBrand block={block}></PageBrand>
		        
		} else if (block.type == 'usps') {
		
		    content = <PageUSPs block={block}></PageUSPs>
		    
		} else if (block.type == 'team') {
		
		    content = <PageTeam block={block}></PageTeam>
		    
		} else if (block.type == 'projects') {
		
		    content = <PageProjects block={block}></PageProjects>
		    
		} else if (block.type == 'news') {
		
		    content = <PageNews block={block}></PageNews>
		
		} else if (block.type == 'partners') {
		
		    content = <PagePartners block={block}></PagePartners>
		    
		} else if (block.type == 'partner_enquiry') {
		
		    content = <PagePartnerEnquiry block={block}></PagePartnerEnquiry>
		    
		} else if (block.type == 'contact') {
		
		    content = <PageContact block={block}></PageContact>
		    
		} else if (block.type == 'contact_pmg') {
		
		    content = <PageContactPMG block={block}></PageContactPMG>
		    
		} else if (block.type == 'contact_willis') {
		
		    content = <PageContactWillis block={block}></PageContactWillis>
		
		} else if (block.type == 'rule') {
		
		    content = <PageRule block={block}></PageRule>
		
		} else if (block.type == 'pattern') {
		
		    content = <PagePattern></PagePattern>
		
		}
    
		return content;
		
    } else {
	    
	    return null;
	    
    }

    

};
export default WithConsumer(PageBlock);